import { get } from 'lodash';
import {
  FETCH_RESERVATION,
  UPDATE_PRE_ORDER_STATUS,
  UPDATE_POSTAL_CODE,
  UPDATE_RESERVATION,
} from '../actionTypes';
import fetchReservationApi from '../../api/fetchReservation';

export const fetchReservation = (urlParams, onSuccess, onError) => {
  return (dispatch, getState) => {
    const { isDefaultPostalCode, params } = getState();

    return fetchReservationApi(urlParams)
      .then((reservation) => {
        dispatch({
          type: FETCH_RESERVATION,
          payload: reservation,
        });

        if (isDefaultPostalCode) {
          const postalCode = get(reservation, 'dealer.address.zipcode')?.split(
            '-'
          )[0];

          const status = get(reservation, 'status');
          if (postalCode) {
            dispatch({
              type: UPDATE_POSTAL_CODE,
              payload: {
                postalCode:
                  status === 'PRE_ORDER_ALLOWED'
                    ? postalCode
                    : params.postalCode,
              },
            });
          }
        }

        onSuccess(reservation);
      })
      .catch((err) => {
        onError(err);
      });
  };
};

export const updatePreOrderStatus = (status) => {
  return (dispatch, getState) => {
    const { reservation } = getState();

    dispatch({
      type: UPDATE_PRE_ORDER_STATUS,
      payload: { ...reservation, isPreOrderCompleted: status },
    });
  };
};

export const updateReservationWithDriveType = (alternateDriveType) => {
  return (dispatch, getState) => {
    const { reservation } = getState();
    dispatch({
      type: UPDATE_RESERVATION,
      payload: { ...reservation, alternateDriveType },
    });
  };
};
